import { useFormik } from "formik";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { getFormErrorMessage, classNames, isFormFieldValid } from "../../../config/global";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputMask } from "primereact/inputmask";
import { SelectButton } from "primereact/selectbutton";
import { useEffect, useRef, useState } from "react";
import CardSeplag from "../../../components/CardSeplag";
import ModalSeplag from "../../../components/ModalSeplag";
import RotuloSeplag from "../../../components/RotuloSeplag";
import { buscarExercicio } from "../../../service/Rag/Exercicio";
import {
  buscarParametroExercicio,
  cadastraParametroExercicio,
  updateParametroExercicio,
} from "../../../service/Monitora/Exercicio";

const ModalMonitoraExercicios = ({
  visible,
  setVisible,
  edit,
  setEdit,
  disabled,
  setDisabled,
  exercicio,
  setAtualizaList,
}) => {
  const [exercicios, setExercicios] = useState([]);
  const [form, setForm] = useState(exercicios);
  const options = ["Não", "Sim"];
  const ativo = ["Sim", "Não"];
  const toast = useRef(null);

  const reject = () => {
    toast.current.show({ severity: "warn", summary: "Rejected", detail: "Operação cancelada", life: 3000 });
  };
  const confirm = (event) => {
    confirmPopup({
      target: event.currentTarget,
      message:
        "Caso o exercicio seja ativado todos os ciclos dos outros exercícios serão fechados. Confirma a execução?",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Confirmar",
      rejectLabel: "Cancelar",
      accept: formik.handleSubmit,
      reject,
    });
  };

  useEffect(() => {
    buscarExercicio().then((res) => {
      setExercicios(res.data);
    });

    startForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const startForm = () => {
    setForm({
      exercicio: null,
      dataAbertura: null,
      dataFechamento: null,
      flagImportaPtaOriginal: "Não",
      flagOrigemPta: "Não",
      flagAtivoMonitora: "Não",
      flagAtualizaSaldo: "Não",
      flagAtualizaPtaGerencial: "Não",
      flagAtualizaStaus: "Não",
      acaoLista: "NENHUMA",
    });
    if (edit || disabled) {
      setForm({
        exercicio: exercicio.exercicio,
        dataAbertura: exercicio.dataAbertura,
        dataFechamento: exercicio.dataFechamento,
        flagImportaPtaOriginal: traduzSimNão(exercicio.flagImportaPtaOriginal),
        flagOrigemPta: traduzSimNão(exercicio.flagOrigemPta),
        flagAtivoMonitora: exercicio.flagAtivoMonitora === "S" ? "Sim" : "Não",
        flagAtualizaSaldo: traduzSimNão(exercicio.flagAtualizaSaldo),
        flagAtualizaPtaGerencial: traduzSimNão(exercicio.flagAtualizaPtaGerencial),
        flagAtualizaStaus: traduzSimNão(exercicio.flagAtualizaStaus),
      });
    }
  };

  const traduzSimNão = (elemento) => {
    if (typeof elemento === "string") {
      if (elemento === "Sim") return "S";
      if (elemento === "S") return "Sim";
      if (elemento === "Não") return "N";
      if (elemento === "N") return "Não";
      if (elemento === "Ativo") return "S";
      if (elemento === "Inativo") return "N";
    }
    return elemento;
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: form,

    validate: (data) => {
      let errors = {};
      if (!data.exercicio) {
        errors.exercicio = "Selecione o Exercício é Obrigatório";
      }
      if (!data.dataAbertura) errors.dataAbertura = "Data de Abertura é Obrigatório";
      if (!data.dataFechamento) errors.dataFechamento = "Data de Fechamento é Obrigatório";

      return errors;
    },

    onSubmit: async (data) => {
      let jsonPost = { parametroExercicio: { ...data }, acaoLista: "CRIAR" };

      if (edit) {
        let updateExercicio = { ...exercicio };
        updateExercicio.flagImportaPtaOriginal = traduzSimNão(data.flagImportaPtaOriginal);
        updateExercicio.flagOrigemPta = traduzSimNão(data.flagOrigemPta);
        updateExercicio.flagAtualizaSaldo = traduzSimNão(data.flagAtualizaSaldo);
        updateExercicio.flagAtualizaPtaGerencial = traduzSimNão(data.flagAtualizaPtaGerencial);
        updateExercicio.flagAtualizaStaus = traduzSimNão(data.flagAtualizaStaus);
        updateExercicio.flagAtivoMonitora = traduzSimNão(data.flagAtivoMonitora);
        updateExercicio.dataAbertura = data.dataAbertura;
        updateExercicio.dataFechamento = data.dataFechamento;

        await updateParametroExercicio(exercicio.idenParametroExercicio, updateExercicio).then((_res) => {
          buscarParametroExercicio().then((respose) => {
            setExercicios(respose.data);
          });
          window.$toast.current.show({ severity: "success", summary: "Sucesso", detail: "Ação efetuada com sucesso!" });
          setVisible(false);
          setEdit(false);
          setDisabled(false);
          setAtualizaList(true);
        });
      }
      if (!edit) {
        jsonPost.parametroExercicio.flagImportaPtaOriginal = traduzSimNão(
          jsonPost.parametroExercicio.flagImportaPtaOriginal
        );
        jsonPost.parametroExercicio.flagOrigemPta = traduzSimNão(jsonPost.parametroExercicio.flagOrigemPta);
        jsonPost.parametroExercicio.flagAtualizaSaldo = traduzSimNão(jsonPost.parametroExercicio.flagAtualizaSaldo);
        jsonPost.parametroExercicio.flagAtualizaPtaGerencial = traduzSimNão(
          jsonPost.parametroExercicio.flagAtualizaPtaGerencial
        );
        jsonPost.parametroExercicio.flagAtualizaStaus = traduzSimNão(jsonPost.parametroExercicio.flagAtualizaStaus);
        jsonPost.parametroExercicio.flagAtivoMonitora = traduzSimNão(jsonPost.parametroExercicio.flagAtivoMonitora);
        jsonPost.parametroExercicio.dataAbertura = jsonPost.parametroExercicio.dataAbertura;
        jsonPost.parametroExercicio.dataFechamento = jsonPost.parametroExercicio.dataFechamento;

        await cadastraParametroExercicio(jsonPost).then((_res) => {
          window.$toast.current.show({ severity: "success", summary: "Sucesso", detail: "Ação efetuada com sucesso!" });
          setVisible(false);
          setVisible(false);
          setEdit(false);
          setDisabled(false);
          setAtualizaList(true);
        });
      }
    },
  });
  const titulo = () => {
    if (edit || disabled) {
      return `Exercício de ${exercicio.exercicio.ano}`;
    }

    return "Habilitar Exercício Orçamentário";
  };
  return (
    <ModalSeplag
      titulo={titulo()}
      tamanho="1200px"
      visible={visible}
      fechar={() => {
        setVisible(false);
        setEdit(false);
        setDisabled(false);
      }}
      type="NONE"
    >
      <Toast ref={toast} />
      <CardSeplag>
        <form>
          <ConfirmPopup />
          <div className="p-fluid grid">
            <div className="field col-12 md:col-12 ">
              <div className="p-fluid grid">
                <div className="field col-12 md:col-4 ">
                  <RotuloSeplag obrigatorio nome={"Selecione o Exercício:"} cols="12 4">
                    <Dropdown
                      placeholder="Selecione o Exercício"
                      id="exercicio"
                      name="exercicio"
                      optionLabel="ano"
                      disabled={edit || disabled}
                      value={formik.values.exercicio}
                      options={exercicios}
                      onChange={(e) => {
                        formik.handleChange(e);
                      }}
                      className={"exercicio " + classNames({ "p-invalid": isFormFieldValid("exercicio", formik) })}
                    />
                    {getFormErrorMessage("exercicio", formik)}
                  </RotuloSeplag>
                </div>
                <div className="field col-12 md:col-4">
                  <span>
                    <RotuloSeplag obrigatorio nome="Data de Abertura:" cols="12 4">
                      <InputMask
                        disabled={disabled}
                        mask="99/99/9999"
                        id="dataAbertura"
                        value={formik.values.dataAbertura}
                        onChange={(e) => formik.handleChange(e)}
                      />
                      {getFormErrorMessage("dataAbertura", formik)}
                    </RotuloSeplag>
                  </span>
                </div>
                <div className="field col-12 md:col-4">
                  <span>
                    <RotuloSeplag obrigatorio nome="Data de Fechamento:" cols="12 4">
                      <InputMask
                        disabled={disabled}
                        mask="99/99/9999"
                        id="dataFechamento"
                        value={formik.values.dataFechamento}
                        onChange={(e) => formik.handleChange(e)}
                      />
                      {getFormErrorMessage("dataFechamento", formik)}
                    </RotuloSeplag>
                  </span>
                </div>
              </div>

              <div className="p-fluid grid">
                {/* <div className="field col-12 md:col-4 ">
                  <span>
                    <RotuloSeplag nome="Importa Pta Original?" cols="12 6">
                      <SelectButton
                        disabled={true}
                        options={options}
                        id="flagImportaPtaOriginal"
                        value={formik.values.flagImportaPtaOriginal}
                        onChange={(e) => formik.handleChange(e)}
                      />
                    </RotuloSeplag>
                  </span>
                </div> */}
                {/* <div className="field col-12 md:col-4">
                  <span>
                    <RotuloSeplag nome="Origem Pta?" cols="12 4">
                      <SelectButton
                        disabled={true}
                        options={options}
                        id="flagOrigemPta"
                        value={formik.values.flagOrigemPta}
                        onChange={(e) => formik.handleChange(e)}
                      />
                    </RotuloSeplag>
                  </span>
                </div> */}
                <div className="field col-12 md:col-4">
                  <span>
                    <RotuloSeplag nome="Ativo" cols="12 4">
                      <SelectButton
                        disabled={disabled}
                        options={ativo}
                        id="flagAtivoMonitora"
                        value={formik.values.flagAtivoMonitora}
                        onChange={(e) => formik.handleChange(e)}
                      />
                    </RotuloSeplag>
                  </span>
                </div>
              </div>
              {/* <div className="p-fluid grid">
                <div className="field col-12 md:col-4 ">
                  <span>
                    <RotuloSeplag nome="Atualiza Saldo?" cols="12 4">
                      <SelectButton
                        disabled={true}
                        options={options}
                        id="flagAtualizaSaldo"
                        value={formik.values.flagAtualizaSaldo}
                        onChange={(e) => formik.handleChange(e)}
                      />
                    </RotuloSeplag>
                  </span>
                </div>
                <div className="field col-12 md:col-4 ">
                  <span>
                    <RotuloSeplag nome="Atualiza Pta Gerencial?" cols="12 4">
                      <SelectButton
                        disabled={true}
                        options={options}
                        id="flagAtualizaPtaGerencial"
                        value={formik.values.flagAtualizaPtaGerencial}
                        onChange={(e) => formik.handleChange(e)}
                      />
                    </RotuloSeplag>
                  </span>
                </div>
                <div className="field col-12 md:col-4">
                  <span>
                    <RotuloSeplag nome="Atualiza Status?" cols="12 4">
                      <SelectButton
                        disabled={true}
                        options={options}
                        id="flagAtualizaStaus"
                        value={formik.values.flagAtualizaStaus}
                        onChange={(e) => formik.handleChange(e)}
                      />
                    </RotuloSeplag>
                  </span>
                </div>
              </div> */}
            </div>
          </div>
        </form>
        <div className="field col-12 md:col-4">
          <RotuloSeplag cols="12 4">
            {!edit && !disabled && (
              <Button
                type="button"
                onClick={confirm}
                icon="pi pi-check"
                label="Habilitar"
                className="p-button-info"
              ></Button>
            )}
            {edit && (
              <Button
                type="submit"
                onClick={formik.handleSubmit}
                icon="pi pi-pi pi-user-edit p-button-icon p-button-icon-left"
                label="Salvar"
                className="p-button-warning p-button p-component"
                style={{ fontSize: "16px" }}
              ></Button>
            )}
          </RotuloSeplag>
        </div>
      </CardSeplag>
    </ModalSeplag>
  );
};
export default ModalMonitoraExercicios;
